// extracted by mini-css-extract-plugin
export default {"mainContainer":"Login_mainContainer__h2yr+","mainText":"Login_mainText__GejX4","secondaryText":"Login_secondaryText__gC11a","blink":"Login_blink__9VB1M"};